






















import { Component, Vue } from "vue-property-decorator";
import { Fragment } from "vue-fragment";
import ReportsFilterProgressCard from "@/components/dashboard/reports.filter.progress.card.component.vue";
import ReportsFilterCard from "@/components/dashboard/reports.filter.card.component.vue";
import { ReportStep } from "@/models/graphql-global-types";
import { UserService } from "@/services/UserService";

@Component({
  props: {},
  components: {
    Fragment,
    ReportsFilterProgressCard,
    ReportsFilterCard
  }
})
export default class ReportFilter extends Vue {
  public ReportStep = ReportStep;
  private isUserAdmin = UserService.isUserAdmin;
  private isUserTester = UserService.isUserTester;
  private isUserViewer = UserService.isUserViewer;
  public mounted() {}
}
